<template>
    <div class="edit-view-container share-container" :class="isFullScreen ? 'fullscreen' : ''">
  
      <v-tooltip
          transition="slide-y-transition"
          close-delay="500"
          content-class="mp4-subtitle-tooltip"
          bottom
        >
          <template v-slot:activator="{ on }">
            <div class="quality-reminder" v-show="mediaControl && mediaControl.type === 'video' && tier === 'basic' && qualityReminder" v-on="on">{{$lang.share.video_quality_reminder}}
              <v-icon
              :size="20"
              class="quality-reminder-icon"
              @click.stop.prevent="onReminderClosed"
            >mdi-close</v-icon>
            </div>
          
          </template>
          <span>{{ $lang.share.video_quality_tooltip }}</span>
        </v-tooltip>
  
      <media-player
        ref="mediaplayer"
      
        @on-screen-switch-toggle="onScreenSwitchToggle"
        :readOnlyPhrases="phrases"
        :videoCuts="transcript && transcript.videoCuts || []"
        :mediaControlInfo="mediaControl"
        :language="transcript && transcript.language"
        :isFullScreen="isFullScreen"
        :isExpanded="true"
        :isTranscriptLoaded="isTranscriptLoaded"
        :isTranscriptCaption="transcript && transcript.transcriptType"
        :readOnly="true"
      />

      <v-toolbar-title class="taption-logo no-nav share-taption-logo">
      <router-link :to="getLogoUrl">
        <img alt="logo" class="share-logo" :src='"../assets/images/logo_green_title.webp"'/>
      </router-link>
      </v-toolbar-title>

      <v-btn
        depressed
        :to="getLoginUrl"
        v-bind:class="{
          'share-item': true,
          'share-login': true
        }"
      >
      <v-icon>{{ localIcons['mdi-login'] }}</v-icon>
        {{$lang.landing.login}}
      </v-btn>
      <!-- <Logo ref="logo" :isTitle="true" :width="150" :color="logoColor" class="show share-logo" :clickable="true" /> -->
      <!-- <v-btn ref="export" class="export show" @click="onExportClicked">
        <v-icon left>save_alt</v-icon>
        <span class="text">{{ $lang.share.export }}</span>
      </v-btn> -->
  
  
      <div class="caption-container" v-bind:class="{'show':isTranscriptLoaded}">
        <editing-panel
          ref="editingpanel"
          :globalPhrases="phrases"
          :duration="mediaControl.duration"
          :speakers="transcript.speakers"
          :showModifiedTooltip="false"
          :pageMode="true"
          :readOnly="true"
          v-bind:class="{'no-space':!isLanguageSpace}"
          @click="onEditingPanelClicked"
           @set-time="(sec, target, noScroll, noAutoPaginate, autoPlay) => $refs.mediaplayer.setMediaTime(sec, target, true, noAutoPaginate, autoPlay)"
           @play-media="() => $refs.mediaplayer.onPlay()"
           @pause-media="() => $refs.mediaplayer.onPaused(true)"
        />
      </div>
  
      <LoaderIcon v-show="!isTranscriptLoaded" :color="loaderColor" class="editing-loader-icon"></LoaderIcon>
  
     <div ref="loginuserinfo" class="login-user-info share-info" :class="getDisplayContainerClass" v-html="fileDisplayName"></div> 
  
      <!-- <export-dialog flat ref="exportdialog" :phrases="phrases" :initialTranscript="transcript" :isShare="true"></export-dialog> -->
    </div>
  </template>
  
  <script>
import { mdiLogin} from '@mdi/js'
  import EditingPanel from "../components/editing/EditingPanel";
 // import ExportDialog from "../components/editing/ExportDialog";
  import MediaPlayer from "../components/media-player/MediaPlayer";
  import LoaderIcon from "../components/icons/LoaderIcon";
 // import mediaUtils from "@/utils/mediaUtils";
//   import storeHelper from "@/utils/storeHelper";
//   const storeModules = storeHelper.createHelpers(["editSession"]);
import userService from "@/connections/user.service";
import textHelper from "@/utils/textManager";
  
  export default {
    components: {
      MediaPlayer,
      EditingPanel,
      LoaderIcon,
    //  ExportDialog,
    },
    data() {
      return {
        isTranscriptLoaded: false,
        phrases: [],
        mediaControl: {
          url: "",
          altUrl:"",
          type: "audio",
          thumbnailUri: "",
          duration: 0,
          activeText: "",
          floatCaptionActive: false,
          stopAtTime: ""
        },
        tier:'',
        isFullScreen: false,
        transcript: {},
        loaderColor: "#2FC59F",
        qualityReminder: true,
      localIcons:{
          'mdi-login':mdiLogin
        }
      };
    },
    name: "edit-transcript",
    methods: {
      //...storeModules.editSession.mapMutations(['setLocalPhrases','overwriteVideoCuts']),
      onOpenSettingDialog(format) {
        const me = this;
        me.$refs.settingdialog.open(format);
      },
      onOpenExportDialog(format) {
        const me = this;
        me.$refs.exportdialog.open(format);
      },
     
      onEditingPanelClicked() {
        const me = this;
  
        if (me.autoPauseClicked) {
          me.pauseMedia();
        }
      },
      onScreenSwitchToggle(){
      //  const me = this;paused
      //  console.log('seitch');
        // if(paused){
        //   me.$refs.loginuserinfo.classList.add('show');
        //   me.$refs.export.$el.classList.add('show');
        //   me.$refs.logo.$el.classList.add('show');
        // }
        // else{
        //   me.$refs.loginuserinfo.classList.remove('show');
        //   me.$refs.export.$el.classList.remove('show');
        //   me.$refs.logo.$el.classList.remove('show');
        // }
      },
   
      pauseMedia() {
        const me = this;
        me.$refs.mediaplayer.onPaused();
      },
      onExportClicked() {
        console.log('export');
        // const me = this;
        // me.$refs.exportdialog.open("txt");
      },
      onReminderClosed(){
        this.qualityReminder = false;
      }
    },
    computed: {
    //   ...storeModules.editSession.mapState({
    //     darkMode: state => state.settings.darkMode
    //   }),
      isLanguageSpace(){

        return false;
        // const me = this;
        //return mediaUtils.isLanguageSpace(me.transcript && me.transcript.language); 
      },
      getDisplayContainerClass(){
        const me = this;
  
        return me.transcript && me.transcript.mediaUrl ? 'extra-wide':'';
      },
      fileDisplayName(){
        const me = this;
        let name = '<div>'+(me.transcript && me.transcript.name) || '' + '</div>';
        if(me.transcript.mediaUrl){
          name += `<br/><a href="${me.transcript.mediaUrl}"> ${me.transcript.mediaUrl}</a>`;
        }
  
        return name;
      },
      logoColor(){
        const me = this;
        return me.darkMode? 'lightgray' :'green';
      },
      getLogoUrl() {
        const language =  textHelper.getDisplayLanguage();
        if(language === 'zh'){
            return { name: "taptiontw" };
        }
        else if(language === 'zh-CN'){
            return { name: "taptioncn" };
        }
        else if(language === 'en-US' || language === 'en'){
            return { name: "taption" };
        }
        else{
            return { name: `taption${language}` };
        }
        },
        getLoginUrl(){
        return textHelper.getAppLoginRoute();
      },
    },
    async mounted() {
        const me = this;
        try{

          me.isTranscriptLoaded = false;
        me.$refs.editingpanel.watchForGlobalPhrases();
        const urlData = me.$route.params.id;
      const chunks = urlData && urlData.split('+');
        if(chunks && chunks.length === 2){
          const shareId = chunks[0];
          const language = chunks[1];

          const buffer = await userService.readTextFile('share',`${shareId}+${language}.txt` )
          const results = await textHelper.getDecompressedJsonString(buffer);

          const phrasesResults = JSON.parse(results.phrases);

          me.transcript = results;
          me.phrases = phrasesResults;
          me.isTranscriptLoaded = true;
          me.mediaControl.duration = results.duration || 0;
          me.mediaControl.type =results.mediaType ||'audio';
          me.mediaControl.url = results.url || results.url2;
        }
        }
        catch{
          me.$router.push({name:'error'});
        }
    },
    created() {
      this.isTranscriptLoaded = false;
    }
  };
  </script>
  <style scoped>
  .logo {
    position: fixed;
    top: 8px;
    left: 15px;
  }
  </style>
  <style>
  
  .dialog-header-top.moveable{
    display:none;
  }
  .speaker-dropdown:hover .speaker-arrow.v-icon {
    transform: rotate(0deg)!important;
    -webkit-transform: rotate(0deg)!important;
    -moz-transform: rotate(0deg)!important;
    -ms-transform: rotate(0deg)!important;
    -o-transform: rotate(0deg)!important;
  }
  
  .speaker-dropdown:hover button {
    background: transparent!important;
    border-radius: 2px;
  }
  
  .fullscreen .caption-container {
    margin-top: 75px;
  }
  .caption-container {
    position: relative;
    margin: 0 auto;
    margin-top: 242px;
    margin-bottom: 50px;
    border-radius: 10px;
    z-index: 0;
    width: 70%;
    background: whitesmoke;
    opacity: 0;
    
    -webkit-transition: all 200ms ease-in-out;
    -moz-transition: all 200ms ease-in-out;
    -o-transition: all 200ms ease-in-out;
    transition: all 200ms ease-in-out;
  }
  
  .caption-container.right-align {
    /* margin-left: 17px; */
    margin: 0 0 0 auto;
    width: 100%;
      padding-left: 370px;
  }
  
  .caption-container.show{
    opacity: 1!important;
  }

  .media-display-container,
  .edit-view-container{
    background:rgba(216,240,236,.2);
  }
  
  .edit-view-container:before {
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    height:100%;
    opacity: 0.15;
    /* background-image:  url("../assets/images/background.webp"); */
    background:rgba(216,240,236,.2);
    background-repeat: repeat;
    padding: 121px;
    background-origin: content-box, padding-box;
  }

  .media-display-container:before,
  .edit-view-container::before{
    content:"";
    background-image: url('../assets/images/login-background.webp')!important;
    background-repeat: repeat;
    opacity: 0.1;
  background-size:contain;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  }
  
  .login-user-info {
    display: flex;
    width: auto;
    background: #e4e9fe;
    min-width: 150px;
    height: 35px;
    position: fixed;
    top: 183px;
    right: 10px;
    padding: 5px 20px 5px 30px;
    font-weight: bold;
    z-index: 1;
    color: #0062ff;
    cursor:default;
  }
  
  .extra-wide{
    height:55px;
    top: 158px;
  }
  .login-user-info a{
    font-weight: 100;
  }
  
  .login-user-info a:hover{
    color:#8ba2eb!important;
  }
  
  .share-info{
    max-width: 33%;
    border-radius: 5px;
  }
  
  .share-info div{
      text-overflow: ellipsis;
      word-break: break-all;
      overflow: hidden;
      white-space: nowrap;
  }

  .share-login{
    border: 1px solid #18e7d3;
    color: #797676!important;
    border-radius: 25px;
    transition: all 0.25s ease-out;
    background: white!important;
    z-index:2;
    position:fixed;
    right:5px;
    top:3px;
  }

  .share-login .v-icon{
    color: #797676!important;
    font-size: 20px;
    width: 20px;
  }
  
  .share-logo{
      background: transparent;
      border-radius: 5px;
      height:52px; 
      width: 200px; 
      display: block;
      /* padding: 5px; */
      /* -webkit-box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%); */
  }

  .share-taption-logo{
    position:fixed;
    z-index:1;
  }
  
  .editing-loader-icon {
    top: calc(50% - 35px) !important;
    left: calc(50% - 35px) !important;
    position: absolute;
  }
  .v-btn.export {
    right: 15px;
    top: 10px;
    z-index: 1;
    position: fixed;
    /* background-color: white !important;
    color: gray; */
        background-color: #0062ff!important;
      color: #fff;
  
    height: 26px !important;
    border-radius: 25px !important;
    min-width: 130px!important;
    
    /* right: 15px;
    top: 10px;
    z-index: 1;
    position: fixed;
    background-color: #0062ff !important;
    color: white;
    height: 26px !important;
    border-radius: 3px !important;
    min-width: 120px!important; */
  }
  .test-message {
    position: fixed;
    z-index: 20 !important;
    top: 240px;
    max-width: 400px;
    max-height: 160px;
    -moz-user-select:none;
    display:none;
  }
  .settings-control-button {
    caret-color: #0062ff !important;
    color: #0062ff !important;
    background: transparent;
    background-color: transparent !important;
    border: 0px solid;
    width: 40px !important;
    height: 40px !important;
    min-width: 0px !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border-radius: 0px;
    padding: 0px !important;
    margin: 0px;
    display:none;
  }
  
  .quality-reminder{
    position: absolute;
      top: 10px;
      width: 334px;
      left: calc(50% - 167px);
      z-index: 2;
      text-align: center;
      background: rgba(0,0,0,0.3);
      border-radius: 3px;
      cursor: default;
      color:white;
  }
  
  .quality-reminder-icon{
    position:absolute;
    color:lightgray!important;
    top:2px;
    right:5px;
  }
  
  .dark .media-display-container {
      background-color: #1c1e21;
  }
  
  .dark .edit-view-container:before {
    background-image:none;
  }
  
  .dark .editing-container {
      background: #3A3B3C;
      border-radius: 10px;
  }
  
  .dark .caption-container {
      background-color: #1c1e21;
  }
  .dark a.start-time, .dark a.end-time {
      color: #E4E9FE!important;
  }
  .dark .phrase-content>span {
      color: white;
  }
  .dark .media-time-end, .dark .media-time-start {
      color: #E4E9FE!important;
       background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(rgba(255, 255, 255, .15)), to(rgba(0, 0, 0, .25))), -webkit-gradient(linear, left top, right bottom, color-stop(0, rgba(255, 255, 255, 0)), color-stop(1.5, rgba(255, 255, 255, .1)), color-stop(0.501, rgba(255, 255, 255, 0)), color-stop(0, rgba(255, 255, 255, 0)));
      margin-left: 0px;
      height: 15px;
  }
  .dark .saving-container {
      background:#606163;
  }
  .dark .login-user-info, .dark.editable-menu-containter {
      background: #3A3B3C!important;
      color: white;
  }
  .dark .share-logo{
      background-color: transparent;
  }
  .dark .v-footer a{
      color: white!important;
  }
  
  .dark .export-dialog{
  background-color: #3A3B3C!important;
  }
  
  @media (max-width: 992px) {
  .media-display-container {
      padding-bottom: 0px;
      padding-top: 0px;
  }
  
  .login-user-info{
      top: 45px;
      width: 100%;
      right: 0px;
      text-align: center;
      background:rgba(0,0,0,0.4);
      opacity: 0.4;
      color:white;
      padding: 0px;
      z-index: 2;
      height: 45px;
      transition: all 0.3s ease; 
      border-radius: 6px;
      opacity:0;
  }
  .login-user-info.show{
      opacity:1;
  }
  
  .login-user-info a{
      color:white!important;
  }
  .login-user-info div{
        width:100%;
  }
  
  .v-btn.export {
    top: 5px;
    overflow: hidden;
    min-width: 50px!important;
    width:50px;
    text-indent: -9999px; 
    z-index: 3!important;
    transform: translateX(250px);
  }
  .v-btn.export.show{
    transform: translateX(0px);
  }
  .v-btn.export i{
    padding:10px;
    width:50px;
    margin: 0 auto!important;
  }
  
  
  .v-btn.export .text{
      display:none
    }
  
  .content-view .logo {
    border-radius: 6px;
    background: rgba(255,255,255,0.7);
    padding:4px;
    left:0px!important;
    top:0px!important;
    margin:0 auto;
    transform: translateY(-160px);
    transition: all 0.3s ease; 
  
  }
  
  .content-view .logo.show{
    transform: translateY(0px);
  }

  .share-login{
    height:30px!important;
  }
  

  .taption-logo.no-nav{
    margin:5px;
    z-index:2;
  }
  .share-logo{
    width:100px!important;
    height:auto;
  }
  .caption-container {
    width:100%;
    margin-top: 265px;
  }
  .audio-placeholder {
    height: 30px;
  }
  .media-container {
    width: 100%!important;
    margin:0px;
    z-index:2;
    background:white;
  }

  
  video.media-player {
    width: 100%!important;
    height: inherit;
    margin-top:35px;
    border-radius: 0px;
  }
  }
  
  
  @media only screen and (max-device-width: 600px) {
    .login-user-info.share-info{
      display:none;
    }
  
    .audio-placeholder{
      width:100%;
    }

    .media-control-container {
      margin-top: 0px!important;
      margin-left:0px!important;
    }
  
    .content-view .logo {
        
      top: 5px;
      left: 10px;
          border-radius: 0px 0px 5px 5px;
        background: white;
        width: 100%;
        padding: 4px;
        text-align: left;
  
    }
    .share-logo{
      width:100px!important;
    }
  
    .share-container .media-slider-container {
        margin-top: 36px!important;
        height: 0px;
        margin-left: 9px!important;
        margin-right: 3px!important;
    }
  
    .dark .content-view .logo{
      background: #3A3B3C;
    }
  
  }
  
  
  
  </style>
  